import { searchParamsToURLSearchParams } from 'lib-shared-url';

import { AppPath } from '../appPaths';

import { AppUrlOptions } from './createAppUrl.types';
import { hasParams } from './utils/hasParams';

/**
 * Creates an internal app url.
 *
 * @param options The url options.
 */
export function createAppUrl<TAppPath extends AppPath>(
  options: AppUrlOptions<TAppPath>,
): string {
  const { path: pathParams, search: searchParams } = {
    path: {},
    search: {},
    ...(hasParams(options) && options.params),
  };

  const search = searchParamsToURLSearchParams(searchParams).toString();
  return options.path
    .replace(/:(\w+)\??/g, (_, param) => pathParams[param] ?? '')
    .concat(search ? `?${search}` : '');
}
